// A soft, self-contained chime for the customer's phone — no audio files.
// Phone browsers block autoplay, so unlockAudio() must run inside a tap handler first
// (we call it when the customer taps "Join the queue").

let ctx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

// Call inside a click/tap handler to satisfy the browser's autoplay policy.
export const unlockAudio = () => {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
};

// One soft bell note: quick attack, gentle exponential decay.
const tone = (c, freq, startAt, duration, peak) => {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(peak, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  osc.connect(gain).connect(c.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.05);
};

// variant "next": one soft note. variant "called": a gentle two-note chime.
export const playChime = (variant = "next") => {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const t = c.currentTime + 0.02;
  if (variant === "called") {
    tone(c, 660, t, 0.6, 0.18);
    tone(c, 880, t + 0.22, 0.75, 0.2);
  } else {
    tone(c, 880, t, 0.7, 0.14);
  }
};
